import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBoxProps {
  defaultValue?: string;
  size?: "sm" | "md";
  className?: string;
}

export default function SearchBox({
  defaultValue = "",
  size = "md",
  className = "",
}: SearchBoxProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  const heightClass = size === "sm" ? "h-10" : "h-11";

  return (
    <form onSubmit={handleSubmit} className={`relative w-full ${className}`} role="search">
      <span
        className="absolute left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400 pointer-events-none"
        aria-hidden="true"
      >
        <i className="ri-search-line text-base"></i>
      </span>
      <input
        type="search"
        name="keyword"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="搜索电影、电视剧名称…"
        aria-label="搜索影视"
        className={`w-full ${heightClass} pl-10 pr-24 text-sm rounded-full bg-background-100 border border-background-200 text-foreground-950 placeholder:text-foreground-400 outline-none transition focus:bg-background-50 focus:border-primary-300 focus:ring-2 focus:ring-primary-100`}
      />
      <button
        type="submit"
        className={`absolute right-1.5 top-1/2 -translate-y-1/2 ${size === "sm" ? "h-7 px-3" : "h-8 px-4"} text-xs font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer`}
      >
        搜索
      </button>
    </form>
  );
}